import { useState } from 'react';

import { IconButton, Stack } from '@mui/material';
import ButtonLink from 'components/ButtonLink/ButtonLink';
import { HamburguerIcon } from 'components/Icons';
import { primaryColors } from 'config/defaultTheme';
import { ROUTES, ROUTES_DEFINITIONS } from 'config/routes/routeDefinitions';
import { useNavigate } from 'react-router-dom';
import { ASSESSMENT_COMMON } from 'utils/constants';

import NavMenu from '../NavMenu/NavMenu';

export interface AdminHeaderProps {
  user: {
    firstName: string;
    lastName: string;
    email: string;
  };
  isBatchReportsEnabled?: boolean;
}

export function AdminHeader({
  user,
  isBatchReportsEnabled = false,
}: AdminHeaderProps) {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const onHamburgerClick = () => {
    setOpen((prev) => !prev);
  };

  return (
    <Stack
      height="4rem"
      p="0.688rem 1rem"
      width="100%"
      justifyContent="left"
      direction="row"
    >
      <IconButton aria-label="menu" sx={{ mr: 2 }} onClick={onHamburgerClick}>
        <HamburguerIcon sx={{ fontSize: 40, fill: primaryColors.midnight }} />
      </IconButton>

      <ButtonLink
        onClick={() => navigate(ROUTES_DEFINITIONS[ROUTES.reports].path)}
      >
        <img
        src={ASSESSMENT_COMMON.logoPath}
        alt={ASSESSMENT_COMMON.logoAlt}
        width="131px"
        height="42px"
        />
      </ButtonLink>

      <NavMenu
        adminUser={{
          firstName: user.firstName,
          lastName: user.lastName,
          email: user.email,
        }}
        isOpen={open}
        onClose={() => setOpen(false)}
        isBatchReportsEnabled={isBatchReportsEnabled}
      />
    </Stack>
  );
}
